import { render, staticRenderFns } from "./LinkedThoughtsWidget.vue?vue&type=template&id=ed60c89e&scoped=true"
import script from "./LinkedThoughtsWidget.vue?vue&type=script&lang=js"
export * from "./LinkedThoughtsWidget.vue?vue&type=script&lang=js"
import style0 from "./LinkedThoughtsWidget.vue?vue&type=style&index=0&id=ed60c89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed60c89e",
  null
  
)

export default component.exports